import React from "react";
import Model from "../../common/Model";

const SubTopicForm = ({
  onClose,
  values,
  handleChange,
  handleBlur,
  errors,
  editId,
  touched,
  handleSubmit,
  loading,
}) => {
  return (
          <Model
            closeModal={onClose}
            title={`${editId ? "Edit" : "Add"} Sub Topic`}
            isForm={true}
            loading={loading}
            handleSubmit={handleSubmit}
          >
            <div className="grid md:grid-cols-2 grid-cols-1 space-y-2 w-full">
              <div>
                <label className="capitalize text-base font-medium text-foreground">
                  Sub Topic Name
                </label>
                <input
                  className="w-full text-base p-2 rounded-xl border selection border-border focus:outline-none focus:border-primary"
                  type="text"
                  placeholder="Enter Sub Topic"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.name && errors.name && (
                  <div className="text-red-500 text-sm">{errors.name}</div>
                )}
              </div>
            </div>
          </Model>
  );
};

export default SubTopicForm;
